import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

// Función para obtener detalles del contacto
export const getContactDetailsOrdersIPB = (orderDetails) => [
  {
    label: 'Teléfono de Contacto',
    value: orderDetails?.phone,
  },
  {
    label: 'Lead ID',
    value: orderDetails?.lead_id,
  },
  {
    label: 'Número de orden',
    value: orderDetails?.order_number,
  },
  {
    label: 'Fecha de pago',
    value: convertToMexicoTime(orderDetails?.order_created),
  },
];

// Nota:

// Este archivo NO define los campos de "Resumen de compra" (Producto, Costo, Costo SIM/eSIM, etc.).
// Esos valores se renderizan desde:
// src/modules/my-sales/submodules/orders/list/components/PurchaseSummary.jsx
// y se habilitan para IPB en la condicion de:
// src/widgets/customDialogComponentDetails/componentsDetails/OrderComponentDialogContent.jsx
// (type === 'detailPurchase' || type === 'DetailsPurchaseOrdersIpb').

// Función para obtener detalles de la dirección
export const getAddressPurchaseOrdersDetails = (orderDetails) => [
  {
    label: 'Tarjeta enmascarada',
    value: orderDetails?.masked_card,
  },
  {
    label: 'Número de autorización',
    value: orderDetails?.authorization_number,
  },
];

// Función para obtener detalles del pedido
export const getOrderPurchaseDetails = (orderDetails) => [
  {
    label: 'Nombre',
    value: orderDetails?.name,
  },
  {
    label: 'Número telefónico',
    value: orderDetails?.phone,
  },
  {
    label: 'Nombre del contacto',
    value: orderDetails?.contact_name,
  },
  {
    label: 'Teléfono de contacto',
    value: orderDetails?.contact_phone,
  },
  {
    label: 'Correo',
    value: orderDetails?.email,
  },
  {
    label: 'Correo del ticket',
    value: orderDetails?.ticket_email,
  },
  {
    label: 'Calle',
    value: orderDetails?.address,
  },
  {
    label: 'Colonia',
    value: orderDetails?.neighborhood,
  },
  {
    label: 'Municipio',
    value: orderDetails?.municipality,
  },
  {
    label: 'Estado',
    value: orderDetails?.state,
  },
  {
    label: 'Código Postal',
    value: orderDetails?.zipcode,
  },
  {
    label: 'Referencia',
    value: orderDetails?.reference,
  },
];

// Función para obtener detalles del pago
export const getDateDetailsPurchaseOrders = (orderDetails) => [
  {
    label: 'Fecha de Creación',
    value: convertToMexicoTime(orderDetails?.created),
  },
];
